import { DOM_EVENT, generateUUID } from '@datadog/browser-core';
import { getActionNameFromElement } from './getActionNameFromElement';
import { LifeCycleEventType } from './lifeCycle';
import { trackEventCounts } from './trackEventCounts';
import { waitIdlePageActivity } from './trackPageActivities';
export var UserActionType;
(function (UserActionType) {
    UserActionType["CLICK"] = "click";
    UserActionType["CUSTOM"] = "custom";
})(UserActionType || (UserActionType = {}));
export function startUserActionCollection(lifeCycle) {
    var userAction = startUserActionManagement(lifeCycle);
    // New views trigger the discard of the current pending User Action
    lifeCycle.subscribe(LifeCycleEventType.VIEW_CREATED, function () {
        userAction.discardCurrent();
    });
    addEventListener(DOM_EVENT.CLICK, processClick, { capture: true });
    function processClick(event) {
        if (!(event.target instanceof Element)) {
            return;
        }
        var name = getActionNameFromElement(event.target);
        if (!name) {
            return;
        }
        userAction.create(UserActionType.CLICK, name);
    }
    return {
        stop: function () {
            userAction.discardCurrent();
            removeEventListener(DOM_EVENT.CLICK, processClick, { capture: true });
        },
    };
}
function startUserActionManagement(lifeCycle) {
    var currentUserAction;
    var currentIdlePageActivitySubscription;
    return {
        create: function (type, name) {
            if (currentUserAction) {
                // Ignore any new user action if another one is already occurring.
                return;
            }
            var pendingAutoUserAction = new PendingAutoUserAction(lifeCycle, type, name);
            currentUserAction = pendingAutoUserAction;
            currentIdlePageActivitySubscription = waitIdlePageActivity(lifeCycle, function (hadActivity, endTime) {
                if (hadActivity) {
                    pendingAutoUserAction.complete(endTime);
                }
                else {
                    pendingAutoUserAction.discard();
                }
                currentUserAction = undefined;
            });
        },
        discardCurrent: function () {
            if (currentUserAction) {
                currentIdlePageActivitySubscription.stop();
                currentUserAction.discard();
                currentUserAction = undefined;
            }
        },
    };
}
var PendingAutoUserAction = /** @class */ (function () {
    function PendingAutoUserAction(lifeCycle, type, name) {
        this.lifeCycle = lifeCycle;
        this.type = type;
        this.name = name;
        this.id = generateUUID();
        this.startTime = performance.now();
        this.eventCountsSubscription = trackEventCounts(lifeCycle);
        this.lifeCycle.notify(LifeCycleEventType.AUTO_ACTION_CREATED, { id: this.id, startTime: this.startTime });
    }
    PendingAutoUserAction.prototype.complete = function (endTime) {
        var eventCounts = this.eventCountsSubscription.eventCounts;
        this.lifeCycle.notify(LifeCycleEventType.AUTO_ACTION_COMPLETED, {
            duration: endTime - this.startTime,
            id: this.id,
            measures: {
                errorCount: eventCounts.errorCount,
                longTaskCount: eventCounts.longTaskCount,
                resourceCount: eventCounts.resourceCount,
            },
            name: this.name,
            startTime: this.startTime,
            type: this.type,
        });
        this.eventCountsSubscription.stop();
    };
    PendingAutoUserAction.prototype.discard = function () {
        this.lifeCycle.notify(LifeCycleEventType.AUTO_ACTION_DISCARDED);
        this.eventCountsSubscription.stop();
    };
    return PendingAutoUserAction;
}());
//# sourceMappingURL=userActionCollection.js.map